import React from 'react';
import { VideoExpander } from './components/video-expander';

const URL = 'https://media.dailycal.org/data/bug-bodycam/website_cut_final.mp4';
export const externalSourceLink = 'https://www.youtube.com/watch?v=rbhCGXOTsng';

export const BugVideoExpander = () => (
  <VideoExpander src={URL} aspectRatio={3840 / 2160} externalSourceLink={externalSourceLink} />
);
